/// <reference path="../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../../node_modules/devextreme/dist/ts/dx.all.d.ts" />

namespace Seac.Commons {
	class ValidationsDisplay {
		private validationForTemplate: string = '<span class="text-danger field-validation-valid" data-valmsg-for="{0}"></span>';

		/**
		 * Controlla se il field è un componete DevExpress e in caso ne ricava l'elemento HTML
		 * @param fieldName Nome del field
		 */
		private dxWidgetElement(fieldName: string): ValidationDxElement { 
			const selectBoxElement: JQuery<HTMLElement> = $(`[name="${fieldName}"]`).parents('.dx-widget.dx-selectbox');
			if (selectBoxElement.length === 1) {
				return <ValidationDxElement> {
					element		: selectBoxElement[0],
					instance	: DevExpress.ui.dxSelectBox.getInstance(selectBoxElement[0])
				};
			}
			const dropdownBoxElement: JQuery<HTMLElement> = $(`[name="${fieldName}"]`).parents('.dx-widget.dx-dropdownbox');
			if (dropdownBoxElement.length === 1) {
				return <ValidationDxElement> {
					element		: dropdownBoxElement[0],
					instance	: DevExpress.ui.dxDropDownBox.getInstance(dropdownBoxElement[0])
				};
			}
			const numberBoxElement: JQuery<HTMLElement> = $(`[name="${fieldName}"]`).parents('.dx-widget.dx-numberbox');
			if (numberBoxElement.length === 1) {
				return <ValidationDxElement> {
					element		: numberBoxElement[0],
					instance	: DevExpress.ui.dxNumberBox.getInstance(numberBoxElement[0])
				};
			}
			const dateBoxElement: JQuery<HTMLElement> = $(`[name="${fieldName}"]`).parents('.dx-widget.dx-datebox');
			if (dateBoxElement.length === 1) {
				return <ValidationDxElement> {
					element		: dateBoxElement[0],
					instance	: DevExpress.ui.dxDateBox.getInstance(dateBoxElement[0])
				};
			}

			const textBoxElement: JQuery<HTMLElement> = $(`[name="${fieldName}"]`).parents('.dx-widget.dx-textbox');
			if (textBoxElement.length === 1) {
				return <ValidationDxElement> {
					element		: textBoxElement[0],
					instance	: DevExpress.ui.dxDateBox.getInstance(textBoxElement[0])
				};
			}
			return null;
		}

		/**
		 * Se il field viene trovato all'interno della pagina mostra il messaggio di errore,
		 * altrimenti potrebbe essere che il field venga renderizzato in un secondo momento e sarà necessario richiamare il metodo
		 * @param fieldName Nome del field per cui mostrare il messaggio
		 * @param errorMessage Messaggio di errore da mostrare
		 */
		public show(fieldName: string, errorMessage: string, gridInstance?: DevExpress.ui.dxDataGrid): boolean {
			let notificationTitle		: string	= Seac.Commons.Constants.stringEmpty; //fieldName;
			let inErrorElement	: JQuery	= $(`[name="${fieldName}"]`);

			if (inErrorElement.length === 0 && fieldName) {
				// Se non ho trovato l'elemento, potrebbe far parte di una lista
				// quindi modifico il nome per es: ArticoloList[0].Prezzo -> ArticoloList[0][Prezzo]

				if (fieldName.indexOf('.') != -1) {
					// Se il fieldName contiene un `.` significa che si tratta di una lista che si trova in questo formato `ArticoloList[0].DatoAggiuntivoList[0].Prova[0].TipoDato`
					// per il corretto funzionameno della visualizzazione degli errori, devo convertire il fieldName senza punti: `ArticoloList[0][DatoAggiuntivoList][0][Prova][0][TipoDato]`
					const regex: RegExp = /\.(.*?)\[/gm;
					let match : RegExpExecArray;
					// Cerco tutte le occorenze all'interno della stringa che inizino con `.` e finiscono con `[`
					while ((match = regex.exec(fieldName)) !== null) {
						// Questo è necessario per evitare loop infiniti nel caso in cui non ci siano match
						if (match.index === regex.lastIndex) {
							regex.lastIndex++;
						}
						// Sostituisco la stringa trovata rimuovendo il punto e mettendo le parentesi quadrate (es: `.DatoAggiuntivoList[` -> `[DatoAggiuntivoList][`)
						fieldName = fieldName.replace(match[0], '[' + match[1] + '][');
					}

					// Rimane l'ultima occorenza, rimuovo il punto e sostituisco con parentesi quadra, ed aggiungo una parentesi quadra in fondo
					fieldName = fieldName.replace('.', '[');
					fieldName += ']'

					inErrorElement = $(`[name="${fieldName}"]`);
				}else {
					// Probabilmente non si tratta di un elemento di una lista perché non c'è l'indice, quindi mostro solamente il messaggio di errore
					Seac.Commons.notificationManager.addSimpleNotification(errorMessage, NotificationType.error, false);

					return true;
				}
			}

			if (inErrorElement.length !== 0) {
				// Estraggo il titolo della notifica dalla label del campo
				// Prima di tutto verifico se si tratta di un field `normale`, quindi cerco la label
				const formGroup: JQuery<HTMLElement> = inErrorElement.parents('.form-group');
				if (formGroup.length === 1) {
					const label: JQuery<HTMLElement> = formGroup.children('label');
					if (label != null) {
						// Prendo solo il testo della label e rimuovo eventuali TAG HTML interni
						notificationTitle = label.clone().children().remove().end().text().toUpperCase().replace(/(\r\n|\n|\r)/gm," ").trim();
					}
				}
				// Altrienti provo a verificare se trovo il titolo all'interno di una griglia
				if (notificationTitle === Seac.Commons.Constants.stringEmpty) {
					const isInDxCell: JQuery<HTMLElement> = inErrorElement.parents('td[role="gridcell"]');
					// Controllo che l'elemento sia di una griglia
					if (isInDxCell.length > 0 && gridInstance === undefined) {
						const idGrid = inErrorElement.attr('name').substr(0, inErrorElement.attr('name').indexOf('['));
						// Se l'id della griglia non è valido non provo nemmeno a cercarla
						if (idGrid) {
							gridInstance = $(`#${idGrid}`).dxDataGrid(Seac.Commons.Constants.DevExpress.dxInstance);
						}
					}
					if (gridInstance && isInDxCell.length === 1) {
						const colIndex: string = $(isInDxCell[0]).attr('aria-colindex');
						if (colIndex) {
							// Se ho un indice di colonna, ricavo il titolo dalla caption della colonna della griglia
							const columnOption: DevExpress.ui.GridBaseColumn = gridInstance.columnOption(+colIndex - 1);
							if (columnOption && columnOption.caption) {
								// Se la colonna è invisibile, non ho nemmeno le option
								notificationTitle = columnOption.caption.toUpperCase();
							}
						}
					}else if (isInDxCell.length === 1) {
						// Se non ho l'istanza della griglia, ma sono all'interno di una griglia. Mostro l'errore senza titolo
						// Sarà onere del backend fornire un messaggio esustivo
						notificationTitle = Seac.Resources.Common.errore;
					}
				}
				// Se non ho ancora trovato il titolo, imposto il nome del field (qui non dovrebbe mai arrivare)
				if (notificationTitle === Seac.Commons.Constants.stringEmpty) {
					notificationTitle = fieldName;
				}

				// Imposto la classe bootstrap che aggiunge il bordo rosso al field
				// Controllo se si tratta di un componente DevExpress
				const devExpressElement: ValidationDxElement = this.dxWidgetElement(fieldName);
				if (devExpressElement) {
					$(devExpressElement.element).addClass(Seac.Commons.Constants.bootstrapInputValidationError);
				}else {
					inErrorElement.addClass(Seac.Commons.Constants.bootstrapInputValidationError);
				}

				// Mostro una notifica con il messaggio di errore, ed imposto una callback che imposta il focus sul field al click sulla notifica
				Seac.Commons.notificationManager.addNotification(
					errorMessage,
					notificationTitle,
					() => {
						if (devExpressElement) {
							devExpressElement.instance.focus();
						}else {
							inErrorElement.focus();
						}
					},
					NotificationType.error,
					false
				)

				// Controllo che sia presente il tag per il field validation, altrimenti lo creo
				// perché serve per la visualizzazione del tooltip di errore
				if ($(`[data-valmsg-for='${fieldName}']`).length === 0) {
					const validationFor: string = this.validationForTemplate.format(fieldName);
					$(validationFor).insertAfter(inErrorElement);
				}

				let tooltipText: string = Seac.Commons.Constants.stringEmpty;
				try {
					// Controllo se esiste già un tooltip per l'elemento
					// In caso positivo recupero il testo che ho depositato nel titolo e faccio il dispose dell'elemento tooltip che reistanzierò successivamente
					const dxTooltip: DevExpress.ui.dxTooltip = $(`[data-valmsg-for='${fieldName}']`).dxTooltip(Seac.Commons.Constants.DevExpress.dxInstance);
					tooltipText = dxTooltip.option(Seac.Commons.Constants.DevExpress.dxTitle);
					dxTooltip.dispose();
				} catch (e) {
					// in caso di eccezione non faccio nulla
				}

				// Imposto il messaggio di errore da visualizzare all'interno del tooltip
				tooltipText = tooltipText !== Seac.Commons.Constants.stringEmpty ? `${tooltipText}, ${errorMessage}` : errorMessage;

				//Rimuovo eventuali tag html dal messaggio di errore del tooltip
				tooltipText = tooltipText.replace( /(<([^>]+)>)/ig, '').trim();

				$(`[data-valmsg-for="${fieldName}"]`).text(tooltipText);

				// Preparo un tooltip che mostrerà l'errore quando il mouse viene posizionato sul field
				$(`[data-valmsg-for='${fieldName}']`).dxTooltip(<DevExpress.ui.dxTooltipOptions>{
					target		: devExpressElement?.element || inErrorElement,
					showEvent	: Seac.Commons.Constants.mouseEnterEvent,
					showTitle	: false,	// Non mostro il titolo
					title		: tooltipText,	// Mi serve solamente per deposiatre il testo nel caso ci siano altri errori da concatenare
					hideEvent	: {
						name: Seac.Commons.Constants.mouseLeaveEvent,
						delay: 300
					}
				});
				return true;
			}else if (!fieldName) {
				// Se fieldName è null si tratta di un errore generico, quindi mostro solamente la notifica
				Seac.Commons.notificationManager.addSimpleNotification(errorMessage, NotificationType.error, false);
				return true;
			}else if ($(document).find(Seac.Commons.Constants.formElement).length === 0) {
				// Ricerco all'interno della stringa l'indice dell'array `[0]`
				const arrayIndex: RegExpMatchArray = fieldName.match(/(\[\d{1,}])/gm);
				if (arrayIndex && arrayIndex.length === 1) {
					// Se l'errore è contenuto in un array, ricavo l'indice della riga e il nome del field
					const rowIndex: string = arrayIndex[0].replace('[', '').replace(']', '');
					fieldName = fieldName.substring(fieldName.lastIndexOf('[') + 1, fieldName.length - 1);

					fieldName = `${fieldName}<br>${Seac.Resources.Common.riga} ${rowIndex + 1}`;
				}

				// Se non ho nessuna form all'interno del documento visualizzo il messaggio di errore (potrebbe essere il caso di una lista)
				Seac.Commons.notificationManager.addTitleNotification(errorMessage, fieldName, NotificationType.error, false);
				return true;
			}else {
				return false;
			}
		}

		/**
		 * Rimuove l'errore di validazione da un singolo field
		 * @param fieldName Nome del field di cui rimuovere la validazione
		 */
		public removeFieldValidation(fieldName: string): void {
			// Svuoto il testo del tooltip
			$(`[data-valmsg-for="${fieldName}"]`).text(Seac.Commons.Constants.stringEmpty);

			// Se esiete elimino il componente tooltip
			try {
				const dxTooltip: DevExpress.ui.dxTooltip = $(`[data-valmsg-for='${fieldName}']`).dxTooltip(Seac.Commons.Constants.DevExpress.dxInstance);
				dxTooltip.dispose();
			} catch (e) {
				// in caso di eccezione non faccio nulla
			}

			// Rimuovo la classe bootstrap che aggiunge il bordo rosso al field
			// Controllo se si tratta di un componente DevExpress
			const devExpressElement: ValidationDxElement = this.dxWidgetElement(fieldName);
			if (devExpressElement) {
				$(devExpressElement.element).removeClass(Seac.Commons.Constants.bootstrapInputValidationError);
			}else {
				const inErrorElement: JQuery = $(`[name="${fieldName}"]`);
				inErrorElement.removeClass(Seac.Commons.Constants.bootstrapInputValidationError);
			}

			// Rimuovo le eventuali notifiche relative al field
			Seac.Commons.notificationManager.removeNotificationByTitle(fieldName);
		}

		/**
		 * Richiamo la funzione per mostrare gli errori ed imposto sul field una proprietà che indica se è stato visualizzato
		 * @param validationArray Array di elementi contenente gli errori
		 * @param gridInstance Se gli errori sono contenuti all'interno di una griglia passo l'istanza della griglia
		 */
		public showValidationArray(validationArray: JQuery<HTMLElement>, gridInstance?: DevExpress.ui.dxDataGrid): void {
			validationArray.each((index: number, element: HTMLElement) => {
				const fieldName: string = $(element).data('field-name');
				const errorMessage: string = $(element)[0].innerHTML;
				const alreadyShown: boolean = $(element).data('data-shown');
				if (!alreadyShown) {
					const shown : boolean = Seac.Commons.validationDisplay.show(fieldName, errorMessage, gridInstance);

					$(element).data('data-shown', shown);
				}
			});
		}

		/** Rimuovo tutte le validazioni all'interno della form */
		public cleanValidations(): void {
			// Elimino tutti i tooltip all'interno della form
			$('form .dx-tooltip').each((index: number, element: HTMLElement) => {  
				$(element).dxTooltip(Seac.Commons.Constants.DevExpress.dxDispose);
			});
			// Rimuovo il bordo rosso da tutti gli input
			$(`form .${Seac.Commons.Constants.bootstrapInputValidationError}`).removeClass(Seac.Commons.Constants.bootstrapInputValidationError);
			// Rimuovo tutte le notifiche dalla pagina
			Seac.Commons.notificationManager.clearNotifications();
		}
	}

	interface ValidationDxElement {
		element	: HTMLElement;
		instance: any;
	}

	export const validationDisplay: ValidationsDisplay = new ValidationsDisplay();

	jQuery(document).ready(() => {
		/** Quando la pagina è stata caricata, controllo se ci sono dei mesaggi di validazione da mostrare e in caso mostro la notifica e preparo il tooltip */
		const validationResults: JQuery<HTMLElement> = $('[data-field-name]');
		Seac.Commons.validationDisplay.showValidationArray(validationResults);

		// Controllo se ci sono delle griglie DevExpress
		// In questo caso potrebbe essere necessario visualizzare gli errori al termine del rendering del content
		const gridElements: JQuery<HTMLElement> = $(`.dx-datagrid[role="grid"]`);
		if (gridElements.length !== 0) {
			gridElements.each((index: number, element: HTMLElement) => {
				const parentItem: JQuery<HTMLElement> = $(element).parent('div.dx-widget');
				if (parentItem.length === 1) {
					// In questo momento dovrei avere una griglia DevExpress, ma per sicurezza metto tutto in un try
					try {
						const gridInstance: DevExpress.ui.dxDataGrid = $(parentItem).dxDataGrid(Seac.Commons.Constants.DevExpress.dxInstance);
						gridInstance.on(Seac.Commons.Constants.DevExpress.dxContentReady, () => {
							Seac.Commons.validationDisplay.showValidationArray(validationResults, gridInstance);
						});
					} catch (e) {
						// Eccezione solo per gli sviluppatori
						console.error(`Non è stato possibile recuperare l'istanza della griglia ${$(parentItem).attr('id')}`);
					}
				}
			});
		}
	});
}
